import { useRouter } from 'next/router';
import { Col, Pagination, Row, Typography } from 'antd';
import queryString from 'query-string';

import pagination from 'src/constants/pagination';
import { PageProps } from 'src/interface/Layout/Pagination';

import classes from './index.module.css';
import React from 'react';

interface Props extends PageProps {
	paginationWithHref?: boolean;
}

const PaginationC = ({ paginationWithHref = false, ...props }: Props) => {
	const router = useRouter();

	const { total = 0, totalPage = 0, pageSize = 0 } = props;
	const hidePagination = totalPage <= 1 || total <= pageSize;

	if (hidePagination) return null;

	const urlObj = queryString.parseUrl(router.asPath);

	return (
		<div className={classes.pagination}>
			<Row gutter={8} justify={props.placement || 'space-between'} align="middle">
				<Col>
					<Pagination
						{...pagination}
						{...props}
						itemRender={(page, _, originalElement) => {
							if (!React.isValidElement(originalElement)) {
								return originalElement;
							}
							if (!paginationWithHref) {
								if (originalElement.type === 'a') {
									const elProps: any = originalElement.props;
									return <a {...elProps} rel="" />;
								}

								return originalElement;
							}

							const elProps: any = originalElement.props;
							const elUrlObj = {
								...urlObj,
								query: { ...urlObj.query, page: page !== 1 ? page : undefined },
							};
							const elHref = queryString.stringifyUrl(elUrlObj);

							return <a {...elProps} href={elHref} rel="follow" />;
						}}
						onChange={(e, s) => {
							if (!paginationWithHref) return props?.onChange?.(e, s);

							return;
						}}
					/>
				</Col>
				{!(props.hideDetail || props.placement) && (
					<Col className="md:text-right mt-2 md:mt-0">
						<Typography.Text>
							Page {props.current ?? props.defaultCurrent} of {props.totalPage}
						</Typography.Text>
					</Col>
				)}
			</Row>
		</div>
	);
};

export default PaginationC;
